import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import POSLayout from '../../../layout/POSLayout';
import QuotationRegistrationPanel from '../../../components/Sales/quotation/components/panel/QuotationRegistrationPanel';

/**
 * 📄 Registrar Cotización
 */
const QuotationRegisterPage = () => {
  return (
    <POSLayout>
      <BreadcrumbTwo />
      <QuotationRegistrationPanel />
    </POSLayout>
  );
};

export default QuotationRegisterPage;
